import { render } from "./FailedCourse.vue?vue&type=template&id=2650e9b7"
import script from "./FailedCourse.vue?vue&type=script&lang=js"
export * from "./FailedCourse.vue?vue&type=script&lang=js"
script.render = render

export default script